export default "__VITE_ASSET__Bic8mm9i__"